module.exports = __webpack_public_path__ + "media/images/icon/icons8-Checkmark-c4a1c6589bcebb7b6d0594cb2af85d83.png";